module.exports = __webpack_public_path__ + "../resources/img/ic_sns_facebook_gray.a9bf2c88.svg";